<template>
  <div class="rightcontent">
      <div class="midContent">
          <div class="content">
            <div ref="webgl" id="webglPano"></div>
            <div :class="[hasModel?'active':'']" ref="webglUp" id="webglPanoUp">
              <div
                v-show="isTopView"
                v-for="(item, i) in getPointInfos"
                v-bind:key="i"
                :style="`left:${item.screenPosX}px;top:${item.screenPosY}px;transform:rotate(${lon + 90}deg)`"
                class="piontOnWebgl"
                ref="piontOnWebgl"
                >
                <img v-if="nowPointActiveIndex===i" src="images/pointInWebglBg.png">
                <div class="centerCircle" @mousedown="movePoint($event, i)"></div>
                <div v-if="nowPointActiveIndex===i" class="outCircle"></div>
              </div>
              <div class="viewBtn" @click="changeView()">
                <el-tooltip class="item" content="点击切换查看视角" placement="left">
                  <i :class="['el-icon-view',isTopView?'isTopView':'']"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
          <BottomBar :nowPanoItemIndex="nowPanoActiveIndex" :resInfos="infos" :resData="resData" :nowFloor="nowFloor"></BottomBar>
      </div>
      <div class="rightBar">
        <div class="rightBarUpWrap">
          <p>
            模型载体
            <i class="el-icon-warning-outline"></i>
          </p>
          <div class="btn" @click="addModelTipShow = true">选择模型</div>
        </div>
        <div class="rightBarLine"></div>
        <div class="rightBarMidWrap">
          <div class="addPointBtn" v-show="hasModel"  @click="pointTipShow = true">添加标记点</div>
          <div class="pointWrap">
            <div class="pointWrapA">
              <el-scrollbar class="page-scroll">
              <div class="pointList">
                <div
                  :class="['point', nowPointActiveIndex===i?'active':'']"
                  v-for="(item, i) in getPointInfos"
                  v-bind:key="i"
                  @click="changePanoMatFromPoint(i)"
                  >
                  <p class="name"><span class="circleIcon"></span>{{item.physicalFile.fileName}}</p>
                  <P class="xWrap">X:
                    <el-input
                      type="text"
                      size="mini"
                      @blur="changePos"
                      @keyup.enter.native="changePos"
                      v-model="item.posX"
                      :disabled="!isTopView||i!==nowPointActiveIndex"
                    >
                    </el-input>
                  </P>
                  <P class="xWrap">Y:
                    <el-input
                      type="text"
                      v-model="item.posY"
                      size="mini"
                      @blur="changePos"
                      @keyup.enter.native="changePos"
                      :disabled="!isTopView||i!==nowPointActiveIndex"
                    >
                      <!-- :disabled="!isTopView" -->
                    </el-input>
                  </P>
                  <P class="xWrap">Z:
                    <el-input
                      type="text"
                      v-model="item.posZ"
                      size="mini"
                      @blur="changePos"
                      @keyup.enter.native="changePos"
                      :disabled="!isTopView||i!==nowPointActiveIndex"
                    >
                    </el-input>
                  </P>
                  <i class="el-icon-delete" @click.stop="deleteMarkPoint($event,item.id,i)"></i>
                </div>
              </div>
              </el-scrollbar>
            </div>
          </div>
        </div>
        <div class="rightBarLine"></div>
        <div class="rightBarDownWrap">
          <el-checkbox v-model="isModelShow" @change="changeIsModelShow()">是否启用模型载体</el-checkbox>
        </div>
      </div>
      <el-drawer
        :visible.sync="pointTipShow"
        title="选择场景添加到模型中"
        @close="panoPointActiveIndex=-1;addPointId=''"
        size="384px">
        <div class="pointTipWrap">
          <div class="rightBarLine"></div>
          <div class="pointTipMidContent">
            <div class="scrollWrap">
            <el-scrollbar class="page-scroll">
              <div class="panoPicListWrap">
                <div class="panoPicList">
                  <div
                    v-for="(item, i) in getPanoWithoutPointInfos"
                    v-bind:key="i"
                    :class="['panoPicWrap',panoPointActiveIndex===i?'active':'']"
                    @click="panoPointActiveIndex=i;addPointId=item.physicalFile.id">
                    <img :src="item.physicalFile.thumbnailUrl">
                    <p>{{item.physicalFile.fileName}}</p>
                  </div>
                  <div class="panoPicWrap">
                  </div>
                  <div class="panoPicWrap">
                  </div>
                  <div class="panoPicWrap">
                  </div>
                </div>
              </div>
            </el-scrollbar>
            </div>
          </div>
          <div class="rightBarLine"></div>
          <div class="pointTipDownContent">
             <el-button
              type="primary"
              @click="addPoint(addPointId)"
             >完成</el-button>
          </div>
        </div>
      </el-drawer>
      <AddModelTip v-if="addModelTipShow" :type="tipType" :closeFunc="closeTip" :submitFunc="addSourceByType"></AddModelTip>
  </div>
</template>
<style>
  .rightcontent *{
    outline: none;
    color: #fff;
    vertical-align: middle;
  }
  .point .el-input__inner{
    height:20px !important;
    padding:0 5px !important;
    vertical-align: middle;
    position:absolute;
    top:5px;
    color:black;
  }
  .rightBarMidWrap .page-scroll{
    height:100% !important;
  }
  .rightBarMidWrap .el-scrollbar__wrap{
    overflow-x:hidden;
    overflow-y:auto;
  }
  .rightBarMidWrap .el-scrollbar__thumb {
    background-color:#aaa;
    height:10px;
  }

  .rightcontent .el-drawer{
    -webkit-box-shadow: 0 2px 10px 0 rgba(0,0,0,.5) !important;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,.5) !important;
    background-color: #333 !important;
    color: #fff !important;
    outline: none;
    font-size: 20px;
  }
  .pointTipWrap .page-scroll{
    height:100% !important;
  }
  .pointTipWrap .el-scrollbar__wrap{
    overflow-x:hidden;
    overflow-y:auto;
  }
  .pointTipWrap .el-scrollbar__thumb {
    background-color:#aaa;
    height:10px;
  }

</style>
<style scoped>
.rightcontent{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: auto;
    flex: auto;
}
.midContent{
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-flow: column nowrap;
    flex-flow: column nowrap;
    background-color: #333;
    color: #fff;
    box-sizing: border-box;
}
.content{
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border-color: #4b4b4b #000 #000 #4b4b4b;
    border-style: solid;
    border-width: 1px;
    box-sizing: border-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-flow: column nowrap;
    flex-flow: column nowrap;
}
.content #webglPanoUp{
  position:absolute;
  width:640px;
  height:360px;
  top: 19px;
  right: 19px;
  overflow: hidden;
  background-color: #333;
  z-index: 3;
}
.content #webglPanoUp.active{
  z-index: 6;
}
.content .viewBtn{
  position:absolute;
  right:5px;
  top:5px;
  font-size:20px;
  cursor: pointer;
}
.content .viewBtn .isTopView{
  color:#0057ff;
}
.content #webglPanoUp .piontOnWebgl{
  width:50px;
  height:50px;
  position:absolute;
  left:0;
  top:0;
  z-index: 99;
}
.content #webglPanoUp .piontOnWebgl img{
  width: 100%;
  height: 100%;
}
.content #webglPanoUp .piontOnWebgl .centerCircle{
  width:14px;
  height:14px;
  background-color: #0057ff;
  border-radius: 50% 50%;
  position:absolute;
  left: 50%;
  top:50%;
  transform: translateX(-50%) translateY(-50%);
  cursor: pointer;
}
.content #webglPanoUp .piontOnWebgl .outCircle{
  width:10px;
  height:10px;
  background-color: #f00;
  border-radius: 50% 50%;
  position:absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 1px;
  cursor: ew-resize;
}
.content #webglPano{
  position:absolute;
  top: 20px;
  left: 20px;
  bottom: 20px;
  right: 20px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .7);
  overflow: hidden;
  border-radius: 2px 2px;
  z-index: 5;
}
.rightBar{
  -ms-flex: 0 0 230px;
  flex: 0 0 230px;
  width: 230px;
  position: relative;
  -webkit-box-flex: 0;
  border-color: #4b4b4b #000 #000 #4b4b4b;
  border-style: solid;
  border-width: 1px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  background-color: #333;
  color: #fff;
}
.rightBarUpWrap {
  position: relative;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 60px;
  flex:  0 0 60px;
  padding: 10px 15px;
}
.rightBarUpWrap p{
  height:40px;
  width: 100px;
  position: absolute;
  line-height: 40px;
  left: 15px;
  font-size: 14px;
  text-align: left;
}
.rightBarUpWrap .btn{
  height:30px;
  width: 100px;
  position: absolute;
  line-height: 30px;
  right: 15px;
  top: 15px;
  font-size: 14px;
  background-color: #0057ff;
  color:#fff;
  cursor: pointer;
  border-radius: 4px 4px;
}
.rightBarMidWrap {
  position: relative;
  -webkit-box-flex:1;
  -ms-flex: 1 auto;
  flex:  1 auto;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  overflow: hidden;
}
.rightBarMidWrap .addPointBtn{
  position: relative;
  -webkit-box-flex:0;
  -ms-flex: 0 0 34px;
  flex:  0 0 34px;
  background-color: #286efa;
  color: #fff;
  line-height: 34px;
  border-radius: 2px 2px;
  margin-top:20px;
  margin-bottom: 20px;
  cursor: pointer;
  width:150px;
  margin-left: 40px;
}
.rightBarMidWrap .pointWrap{
  position: relative;
  -webkit-box-flex:1;
  -ms-flex: 1 auto;
  flex:  1 auto;
  overflow: hidden;
}
.rightBarMidWrap .pointWrapA{
  position: relative;
  width: 100%;
  height: calc(100vh - 240px);
  overflow: hidden;
}
.rightBarMidWrap .pointList{
  position: relative;
  width:100%;
  overflow: hidden;
}
.rightBarMidWrap .point{
   position: relative;
   width:100%;
   height: 120px;
   background-color: #3a3a3a;
   margin-bottom: 10px;
   cursor: pointer;
}
.rightBarMidWrap .point .name{
  position: relative;
  height:30px;
  left:10px;
  line-height: 30px;
  text-align: left;
  text-indent: 20px;
  font-size: 16px;
}
.rightBarMidWrap .point .name .circleIcon{
  display: block;
  width:12px;
  height: 12px;
  position: absolute;
  background-color: #999;
  border-radius: 6px 6px;
  top: 9px;
}
.rightBarMidWrap .point.active .circleIcon{
  background-color: #fbd14b;
}
.rightBarMidWrap .point i{
  position: absolute;
   height:30px;
   right:30px;
   line-height: 30px;
   top:0;
  font-size: 16px;
  cursor: pointer;
}
.rightBarMidWrap .point .xWrap{
  height:30px;
  position: relative;
  vertical-align: middle;
  line-height: 30px;
  text-align: left;
  font-size: 16px;
  text-indent: 10px;
}
.rightBarMidWrap .point .xWrap .el-input{
  position: absolute;
  width:180px;
  font-size: 16px;
  left: 30px;
}
.rightBarLine{
  width: 100%;
  height: 2px;
  border-top: 1px solid rgb(0, 0, 0);
  border-bottom: 1px solid rgb(75, 75, 75);
}
.rightBarDownWrap{
  -webkit-box-flex: 0;
  -ms-flex: 0 0 60px;
  flex: 0 0 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 15px;
}
.pointTipWrap{
  position: relative;
  width:100%;
  height:100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  color: #fff;
}
.pointTipWrap .pointTipMidContent{

  -webkit-box-flex: 1;
  -ms-flex: 1 auto;
  flex: 1 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  padding: 20px 15px;
}
.pointTipWrap .scrollWrap {
  position: relative;
  width: 100%;
  height: calc(100vh - 185px);
  overflow-y: auto;
  overflow-x: hidden;
}
.pointTipWrap .panoPicListWrap{
  position: relative;
  width:100%;
  height:100%;
  overflow: hidden;
}
.pointTipWrap .panoPicList{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
/* .pointTipWrap .panoPicList:after {
    content: "";
    flex: auto;
 } */

.pointTipWrap .pointTipMidContent .panoPicWrap{
  width: 100px;
  margin-bottom: 20px;
  cursor: pointer;
}
.pointTipWrap .pointTipMidContent .panoPicWrap.active img{
  outline: 2px solid #ffbd10;
  outline-offset: -2px;
}
.pointTipWrap .panoPicWrap img{
  width: 100px;
  height: 100px;
}
.pointTipWrap .panoPicWrap p{
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
}

.pointTipWrap .pointTipDownContent{
  -webkit-box-flex: 0;
  -ms-flex: 0 0 60px;
  flex: 0 0 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 100px;
  text-align: center;
}
.pointTipWrap .pointTipDownContent button{
  -webkit-box-flex: 1;
  -ms-flex: 1 auto;
  flex: 1 auto;
}

</style>
<script>
import BottomBar from '../components/webgl/BottomBar.vue'
import AddModelTip from '../components/database2.vue'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader_z'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min'
import https from '../https.js'
import zcfCommon from '../../public/com/zcf_common'
let vm = null
const vertexShader = [
  'varying vec3 pPos;',
  'void main()',
  '{',
  '    pPos = position;',
  '    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );',
  '    gl_Position = projectionMatrix * mvPosition;',
  '}'
].join('\n')

const fragmentShader = [
  '#ifdef GL_ES',
  '    precision highp float;',
  '#endif',
  'const float PI = 3.1415926;',
  'const float TWO_PI = 6.2831852;',

  'uniform samplerCube texture;',
  'uniform vec3 cPosition;',
  'varying vec3 pPos;',
  'void main()',
  '{',
  '    vec3 np = normalize(pPos-cPosition);',
  '    gl_FragColor = textureCube( texture, vec3(np.x,np.y,-np.z ));',
  '}'
].join('\n')
export default {
  name: '',
  components: {
    BottomBar,
    AddModelTip
  },
  computed: {
    nowPointActiveIndex: function() {
      return this.panoEditInfos.nowPointActiveIndex
    },
    nowPanoActiveIndex: function() {
      return this.panoEditInfos.nowPanoActiveIndex
    },
    getPanoInfos: function() {
      var arr = []
      console.log('getPanoInfos内容变换了')
      if(this.hasInit && this.resData[this.nowFloor].panos) {
        arr = this.resData[this.nowFloor].panos
      }
      return arr
    },
    getModel: function() {
      var model = {}
      if(this.hasInit && this.resData[this.nowFloor].model) {
        model = this.resData[this.nowFloor].model
      }
      return model
    },
    getPointInfos: function() {
      var arr = []
      console.log('getPointInfos内容变换了')
      if(this.hasInit && this.resData[this.nowFloor].panos) {
        for(var i = 0; i < this.resData[this.nowFloor].panos.length; i++) {
          if(this.resData[this.nowFloor].panos[i].posX != null) {
            arr.push(this.resData[this.nowFloor].panos[i])
          }
        }
      }
      return arr
    },
    getPanoWithoutPointInfos: function() {
      var arr = []
      console.log('pointInfos内容变换了')
      if(this.hasInit && this.resData[this.nowFloor].panos) {
        for(var i = 0; i < this.resData[this.nowFloor].panos.length; i++) {
          if(this.resData[this.nowFloor].panos[i].posX == null) {
            arr.push(this.resData[this.nowFloor].panos[i])
          }
        }
      }
      return arr
    }
  },
  props: ['infos', 'panoEditInfos', 'nowFloor', 'resData'],
  data() {
    return {
      lon: 270,
      lat: 0,
      phi: 0,
      theta: 0,
      x: 0,
      y: 0,
      z: 0,
      useModel: false,
      pointTipShow: false,
      addPanoBtnCanUse: false,
      panoPointActiveIndex: -1,
      // nowPointActiveIndex: 0,
      // nowPanoActiveIndex: 0,
      // getPointInfos: [],
      addPointId: '',
      isTopView: true,
      addModelTipShow: false,
      tipType: '3',
      hasModel: false,
      hasInit: false,
      modelData: {},
      isModelShow: false
    }
  },
  created() {
    document.oncontextmenu = function() {
      return false
    }
    vm = this
    if(this.resData && this.resData.length > 0) {
      this.hasInit = true
      this.isModelShow = this.resData[this.nowFloor].isModelShow
      var id = this.resData[this.nowFloor].panos[this.nowPanoActiveIndex].id
      var pointNum = this.getPointInfos.findIndex(item => item.id === id)
      this.$parent.changePanoEditInfos('nowPointActiveIndex', pointNum)
    }
  },
  watch: {
    resData(val) {
      if(!this.hasInit) {
        this.hasInit = true
        this.generatePano(this.panoGroup, this.resData[this.nowFloor].panos[this.nowPanoActiveIndex])
        this.isModelShow = this.resData[this.nowFloor].isModelShow
        var id = this.resData[this.nowFloor].panos[this.nowPanoActiveIndex].id
        var pointNum = this.getPointInfos.findIndex(item => item.id === id)
        this.$parent.changePanoEditInfos('nowPointActiveIndex', pointNum)
        this.initModel(0)
      }
    }
  },
  mounted () {
    this.containerUp = null
    this.sceneUp = null
    this.cameraUp = null
    this.meshUp = null
    this.rendererUp = null
    this.containerWUp = 0
    this.containerHUP = 0
    this.targetBoxUp = null
    this.rafId = null
    this.container = null
    this.scene = null
    this.camera = null
    this.mesh = null
    this.renderer = null
    this.controls = null
    this.containerW = 0
    this.containerH = 0
    this.selectionBox = null
    this.transformControls = null
    this.mouse = new THREE.Vector2()
    this.raycaster = new THREE.Raycaster()
    this.onDownPosition = new THREE.Vector2()
    this.onUpPosition = new THREE.Vector2()
    this.pmremGenerator = null
    this.isDown = false
    this.isMoving = false
    this.isModelShow = false
    this.panoGroup = new THREE.Group()
    this.fingers = null
    this.onPointerDownPointerX = 0
    this.onPointerDownPointerY = 0
    this.onPointerDownLon = 0
    this.onPointerDownLat = 0
    this.onPointerDownPointerX0 = 0
    this.onPointerDownPointerY0 = 0
    this.onPointerDownPointerX1 = 0
    this.onPointerDownPointerY1 = 0
    this.preMoveX = 0
    this.preMoveY = 0
    this.offX = 0
    this.offY = 0
    this.disFinger = 0
    this.canDamp = false
    this.dampingFactor = 0.2
    this.targetBox = null
    this.hasLoaded = false
    this.planeUniforms = null
    this.preV = new THREE.Vector2()
    this.textrueLoader = new THREE.TextureLoader()
    this.clock = new THREE.Clock()
    // this.getZoom('piontOnWebgl', 'webglUp')
    this.init()
    this.animate()
  },
  methods: {
    changeIsModelShow() {
      this.resData[this.nowFloor].isModelShow = this.isModelShow
    },
    deleteMarkPoint(ev, id, num) {
      var index = -1
      for(var i = 0; i < this.getPanoInfos.length; i++) {
        if(this.resData[this.nowFloor].panos[i].id === id) {
          index = i
          this.resData[this.nowFloor].panos[i].posX = null
          this.resData[this.nowFloor].panos[i].posY = null
          this.resData[this.nowFloor].panos[i].posZ = null
          this.resData[this.nowFloor].panos[i].screenPosX = null
          this.resData[this.nowFloor].panos[i].screenPosY = null
        }
      }
      if(this.getPointInfos.length > num) {
        this.$parent.changePanoEditInfos('nowPointActiveIndex', num)
      }else{
        this.$parent.changePanoEditInfos('nowPointActiveIndex', num - 1)
      }
      this.changePanoMatFromPoint(this.nowPointActiveIndex)
      // if(index === this.panoEditInfos.nowPointActiveIndex) {
      //   this.panoEditInfos.nowPointActiveIndex = -1
      // }
    },
    closeTip() {
      this.addModelTipShow = false
    },
    addSourceByType(data) {
      console.log(data)
      this.resData[this.nowFloor].model = {
        id: data[0].id,
        icon: data[0].icon,
        modelType: data[0].sceneType,
        name: data[0].name,
        path: data[0].path
      }
      !this.hasModel ? this.initModel(this.nowFloor) : this.changeModel()
    },
    changeView() {
      if(this.nowPointActiveIndex !== -1) {
        if(this.isTopView) {
          this.isTopView = false
          var pos = this.getPointInfos[this.nowPointActiveIndex]
          this.cameraUp.position.set(parseFloat(pos.posX), parseFloat(pos.posY), parseFloat(pos.posZ))
          console.log(this.cameraUp.position)
          this.posObj(this.targetBoxUp, this.cameraUp, 10000, this.lon, this.lat, 0)
          console.log(this.targetBoxUp.position)
        }else{
          this.isTopView = true
          this.cameraUp.position.set(0, this.modelData.r, 0)
          this.targetBoxUp.position.set(0, 0, 0)
        }
      }
    },
    addPoint(id) {
      if(id !== '') {
        for(var i = 0; i < this.getPanoInfos.length; i++) {
          if(this.resData[this.nowFloor].panos[i].physicalFile.id === id) {
            this.resData[this.nowFloor].panos[i].posX = 0
            this.resData[this.nowFloor].panos[i].posY = 0
            this.resData[this.nowFloor].panos[i].posZ = 0
            var pos = new THREE.Vector3(0, 0, 0)
            var vec = pos.project(this.cameraUp)
            this.resData[this.nowFloor].panos[i].screenPosX = Math.round(vec.x * 320 + 320) - 25
            this.resData[this.nowFloor].panos[i].screenPosY = Math.round(-vec.y * 180 + 180) - 25
            this.$parent.changePanoEditInfos('nowPanoActiveIndex', i)
          }
        }
        this.pointTipShow = false
        this.$parent.changePanoEditInfos('nowPointActiveIndex', this.getPointInfos.length - 1)
        this.changePanoMat(this.nowPanoActiveIndex)
      }else{
        this.$notify({
          title: '警告',
          message: '请选择需要添加点的全景图',
          duration: 2000,
          type: 'warning'
        })
      }
    },
    changePos() {
      if(this.isTopView) {
        var pos = new THREE.Vector3(
          parseFloat(this.getPointInfos[this.nowPointActiveIndex].posX),
          parseFloat(this.getPointInfos[this.nowPointActiveIndex].posY),
          parseFloat(this.getPointInfos[this.nowPointActiveIndex].posZ)
        )
        var vec = pos.project(this.cameraUp)
        // this.getPointInfos[this.nowPointActiveIndex].screenPos.x = Math.round(vec.x * 320 + 320) - 25
        // this.getPointInfos[this.nowPointActiveIndex].screenPos.y = Math.round(-vec.y * 180 + 180) - 25

        this.resData[this.nowFloor].panos[this.nowPanoActiveIndex].screenPosX = Math.round(vec.x * 320 + 320) - 25
        this.resData[this.nowFloor].panos[this.nowPanoActiveIndex].screenPosY = Math.round(-vec.y * 180 + 180) - 25
      }else{
        // this.$notify({
        //   title: '警告',
        //   message: '请在顶视图视角下面调整点的位置',
        //   duration: 2000,
        //   type: 'warning'
        // })
        var posX = this.getPointInfos[this.nowPointActiveIndex].posX
        var posY = this.getPointInfos[this.nowPointActiveIndex].posY
        var posZ = this.getPointInfos[this.nowPointActiveIndex].posZ
        this.cameraUp.position.set(parseFloat(posX), parseFloat(posY), parseFloat(posZ))
        this.posObj(this.targetBoxUp, this.cameraUp, 10000, this.lon, this.lat, 0)
      }
    },
    movePoint(ev, num) {
      var oEvent = ev || event
      oEvent.preventDefault()
      var prePosX = oEvent.clientX
      var prePosY = oEvent.clientY
      var preLeft = vm.getPointInfos[vm.nowPointActiveIndex].screenPosX
      var preTop = vm.getPointInfos[vm.nowPointActiveIndex].screenPosY
      var nowLeft, nowTop, offsetX, offsetY
      this.changePanoMatFromPoint(num)
      var onMouseMove = function(ev) {
        var oEvent = ev || event
        offsetX = oEvent.clientX - prePosX
        offsetY = oEvent.clientY - prePosY
        if(Math.abs(offsetX) > 1 || Math.abs(offsetY) > 1) {
          nowLeft = preLeft + offsetX
          nowTop = preTop + offsetY
          if(nowLeft >= -25 && nowLeft <= 640 - 25) {
            vm.getPointInfos[vm.nowPointActiveIndex].screenPosX = nowLeft
          }
          if(nowTop >= -25 && nowTop <= 360 - 25) {
            vm.getPointInfos[vm.nowPointActiveIndex].screenPosY = nowTop
          }
          vm.mouse.x = ((vm.getPointInfos[vm.nowPointActiveIndex].screenPosX + 25 - 640) / 640) * 2 + 1
          vm.mouse.y = -((vm.getPointInfos[vm.nowPointActiveIndex].screenPosY + 25 - 360) / 360) * 2 - 1
          vm.raycaster.setFromCamera(vm.mouse, vm.cameraUp)
          const intersections = vm.raycaster.intersectObjects(vm.mesh.children, true)
          if(intersections.length > 0) {
            vm.getPointInfos[vm.nowPointActiveIndex].posX = (intersections[0].point.x).toFixed(2)
            vm.getPointInfos[vm.nowPointActiveIndex].posZ = (intersections[0].point.z).toFixed(2)
          }
          console.log(vm.getPointInfos)
        }
      }
      document.addEventListener('mousemove', onMouseMove, false)
      var onMouseUp = function(ev) {
        document.removeEventListener('mousemove', onMouseMove, false)
        document.removeEventListener('mouseup', onMouseUp, false)
      }
      document.addEventListener('mouseup', onMouseUp, false)
    },
    init () {
      this.container = this.$refs.webgl
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.scene = new THREE.Scene()
      this.targetBox = new THREE.Mesh(
        new THREE.BoxBufferGeometry(1, 1, 1),
        new THREE.MeshBasicMaterial({
          color: 0xff0000,
          transparent: true,
          opacity: 0
        })
      )
      this.scene.add(this.targetBox)
      this.scene.add(this.panoGroup)
      this.camera = new THREE.PerspectiveCamera(
        60,
        this.containerW / this.containerH,
        10,
        99999
      )

      this.camera.position.set(0, 0, 0)
      this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
      this.camera.lookAt(this.targetBox.position)
      this.scene.add(this.camera)

      const ambientLight = new THREE.AmbientLight(0xffffff)
      this.scene.add(ambientLight)
      this.planeUniforms = {
        cPosition: { value: new THREE.Vector3() },
        texture: { value: null },
        ...THREE.UniformsLib.lights
      }
      const planeMat = new THREE.ShaderMaterial({
        uniforms: this.planeUniforms,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        lights: true
      })
      planeMat.needsUpdate = true

      if(this.resData.length > 0 && this.resData[this.nowFloor].panos) {
        this.generatePano(this.panoGroup, this.resData[this.nowFloor].panos[this.nowPanoActiveIndex])
      }
      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      })
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.setSize(this.containerW, this.containerH)
      this.container.appendChild(this.renderer.domElement)
      window.addEventListener('resize', this.onresize, false)

      this.renderer.domElement.addEventListener('mousedown', this.onRendererMouseDown, false)
      this.renderer.domElement.addEventListener('mousemove', this.onRendererMouseMove, false)
      this.renderer.domElement.addEventListener('mouseup', this.onRendererMouseUp, false)


      /**
       * 顶层模型
       */
      this.containerUp = this.$refs.webglUp
      this.containerWUp = this.containerUp.getBoundingClientRect().width
      this.containerHUp = this.containerUp.getBoundingClientRect().height
      this.sceneUp = new THREE.Scene()

      this.targetBoxUp = new THREE.Mesh(
        new THREE.BoxBufferGeometry(1, 1, 1),
        new THREE.MeshBasicMaterial({
          color: 0xff0000,
          transparent: true,
          opacity: 0
        })
      )
      this.targetBoxUp.position.set(0, 0, 0)
      this.sceneUp.add(this.targetBoxUp)
      this.cameraUp = new THREE.PerspectiveCamera(
        60,
        this.containerWUp / this.containerHUp,
        10,
        99999
      )
      this.cameraUp.lookAt(this.targetBoxUp.position)
      this.sceneUp.add(this.cameraUp)

      var ambientLightUp = new THREE.AmbientLight(0xffffff)
      this.sceneUp.add(ambientLightUp)

      var directionalLightUp01 = new THREE.DirectionalLight(0xffffff, 1.2)
      directionalLightUp01.position.set(100, 100, 100)
      this.sceneUp.add(directionalLightUp01)

      var directionalLightUp02 = new THREE.DirectionalLight(0xffffff, 0.8)
      directionalLightUp02.position.set(-100, 0, -100)
      this.sceneUp.add(directionalLightUp02)


      this.initModel(this.nowFloor)

      this.rendererUp = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      })
      this.rendererUp.setPixelRatio(window.devicePixelRatio)
      this.rendererUp.setSize(this.containerWUp, this.containerHUp)
      this.containerUp.appendChild(this.rendererUp.domElement)
    },
    changeModel() {
      var modelLoader = new GLTFLoader()
      var dracoLoader = new DRACOLoader()
      dracoLoader.setDecoderPath('com/draco/gltf/')
      modelLoader.setDRACOLoader(dracoLoader)
      modelLoader.setPath(this.resData[this.nowFloor].model.path + '/')
      modelLoader.load('model.gltf', gltf => {
        this.sceneUp.remove(this.mesh)
        this.mesh.traverse(function (child) {
          if(child instanceof THREE.Mesh) {
            child.geometry.dispose()
            if(child.material.length > 1) {
              for(var i = 0; i < child.material.length; i++) {
                child.material[i].dispose()
              }
            }else {
              child.material.dispose()
            }
          }
        })
        this.mesh = null
        this.hasModel = true
        this.mesh = gltf.scene
        this.sceneUp.add(this.mesh)
      })
    },
    initModel(num) {
      if(this.hasInit && this.resData[num].model) {
        var modelLoader = new GLTFLoader()
        var dracoLoader = new DRACOLoader()
        dracoLoader.setDecoderPath('com/draco/gltf/')
        modelLoader.setDRACOLoader(dracoLoader)
        modelLoader.setPath(this.resData[num].model.path + '/')
        modelLoader.load('model.gltf', gltf => {
          this.mesh = gltf.scene
          this.sceneUp.add(this.mesh)
          this.hasModel = true
          this.modelData = zcfCommon.getModelDate(this.mesh, THREE)
          this.cameraUp.position.set(0, this.modelData.r, 0)
          // for(var i = 0; i < this.resData[this.nowFloor].panos.length; i++) {
          //   if(this.resData[this.nowFloor].panos[i].position != null) {
          //     var pos = new THREE.Vector3(this.resData[this.nowFloor].panos[i].position.x, this.resData[this.nowFloor].panos[i].position.y, this.resData[this.nowFloor].panos[i].position.z)
          //     var vec = pos.project(this.cameraUp)
          //     this.resData[this.nowFloor].panos[i].screenPos.x = Math.round(vec.x * 320 + 320) - 25
          //     this.resData[this.nowFloor].panos[i].screenPos.y = Math.round(-vec.y * 180 + 180) - 25
          //   }
          // }
          // for(var i = 0; i < this.getPointInfos.length; i++) {
          //   var pos = new THREE.Vector3(this.getPointInfos[i].posX, this.getPointInfos[i].posY, this.getPointInfos[i].posZ)
          //   var vec = pos.project(this.cameraUp)
          //   this.getPointInfos[i].screenPosX = Math.round(vec.x * 320 + 320) - 25
          //   this.getPointInfos[i].screenPosY = Math.round(-vec.y * 180 + 180) - 25
          // }
        })
      }
    },
    onRendererMouseDown(event) {
      event.preventDefault()
      this.isMoving = false
      this.isDown = true
      this.canDamp = false
      this.preV.x = event.clientX
      this.preV.y = event.clientY
      this.preMoveX = this.onPointerDownPointerX = event.clientX
      this.preMoveY = this.onPointerDownPointerY = event.clientY
      this.onPointerDownLon = this.lon
      this.onPointerDownLat = this.lat
    },
    onRendererMouseMove(event) {
      event.preventDefault()
      this.isMoving = true
      if(this.isDown) {
        this.lon = (this.onPointerDownPointerX - event.clientX) * 0.15 + this.onPointerDownLon
        this.lat = (event.clientY - this.onPointerDownPointerY) * 0.15 + this.onPointerDownLat
        this.posObj(this.targetBox, this.camera, 1, this.lon, this.lat, 0)
        if(!this.isTopView && this.nowPointActiveIndex !== -1) {
          this.posObj(this.targetBoxUp, this.cameraUp, 1, this.lon, this.lat, 0)
        }
        this.offX = event.clientX - this.preMoveX
        this.offY = event.clientY - this.preMoveY
        this.preMoveX = event.clientX
        this.preMoveY = event.clientY
      }
    },
    onRendererMouseUp() {
      this.isMoving = false
      this.isDown = false
    },
    changePanoMatFromPoint(num) {
      // this.nowPointActiveIndex = num
      this.$parent.changePanoEditInfos('nowPointActiveIndex', num)
      var id = this.getPointInfos[num].id
      var panoNum = this.getPanoInfos.findIndex(item => item.id === id)
      this.$parent.changePanoEditInfos('nowPanoActiveIndex', panoNum)
      // this.nowPanoActiveIndex = panoNum
      this.lon = 270
      this.lat = 0
      this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
      console.log(this.nowPanoActiveIndex)
      var r = this.resData[this.nowFloor].panos[this.nowPanoActiveIndex].physicalFile.filePath
      var urls = [
        r + '/creat/l1_r_1_1.jpg',
        r + '/creat/l1_l_1_1.jpg',
        r + '/creat/l1_u_1_1.jpg',
        r + '/creat/l1_d_1_1.jpg',
        r + '/creat/l1_f_1_1.jpg',
        r + '/creat/l1_b_1_1.jpg'
      ]

      var textureCube = new THREE.CubeTextureLoader().load(urls)
      textureCube.format = THREE.RGBFormat
      textureCube.mapping = THREE.CubeRefractionMapping
      this.panoGroup.children[0].material.uniforms.texture.value = textureCube
      if(!this.isTopView) {
        var info = this.getPointInfos[this.nowPointActiveIndex]

        this.cameraUp.position.set(parseFloat(info.posX), parseFloat(info.posY), parseFloat(info.posZ))
        this.posObj(this.targetBoxUp, this.cameraUp, 10000, this.lon, this.lat, 0)
      }
    },
    changePanoMat(num) {
      // this.nowPanoActiveIndex = num
      this.$parent.changePanoEditInfos('nowPanoActiveIndex', num)
      var id = this.getPanoInfos[num].id
      var pointNum = this.getPointInfos.findIndex(item => item.id === id)
      // this.nowPointActiveIndex = pointNum
      this.$parent.changePanoEditInfos('nowPointActiveIndex', pointNum)
      this.lon = 270
      this.lat = 0
      this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
      var r = this.resData[this.nowFloor].panos[this.nowPanoActiveIndex].physicalFile.filePath
      var urls = [
        r + '/creat/l1_r_1_1.jpg',
        r + '/creat/l1_l_1_1.jpg',
        r + '/creat/l1_u_1_1.jpg',
        r + '/creat/l1_d_1_1.jpg',
        r + '/creat/l1_f_1_1.jpg',
        r + '/creat/l1_b_1_1.jpg'
      ]
      // var urls = [
      //   r + '/1_r.jpg',
      //   r + '/1_l.jpg',
      //   r + '/1_u.jpg',
      //   r + '/1_d.jpg',
      //   r + '/1_f.jpg',
      //   r + '/1_b.jpg'
      // ]
      var textureCube = new THREE.CubeTextureLoader().load(urls)
      textureCube.format = THREE.RGBFormat
      textureCube.mapping = THREE.CubeRefractionMapping
      this.panoGroup.children[0].material.uniforms.texture.value = textureCube
      if(!this.isTopView && this.nowPointActiveIndex !== -1) {
        var pos = this.getPointInfos[this.nowPointActiveIndex].position
        this.cameraUp.position.set(parseFloat(pos.x), parseFloat(pos.y), parseFloat(pos.z))
        this.posObj(this.targetBoxUp, this.cameraUp, 10000, this.lon, this.lat, 0)
      }
    },
    changePanoMatByFloor(num, num2) {
      this.hasModel = false
      this.$parent.changePanoEditInfos('nowPanoActiveIndex', num)
      console.log(this.resData[num2].panos.posX == null)
      if(this.resData[num2].panos[0].posX != null) {
        this.$parent.changePanoEditInfos('nowPointActiveIndex', 0)
      }else{
        this.$parent.changePanoEditInfos('nowPointActiveIndex', -1)
      }
      this.sceneUp.remove(this.mesh)
      this.mesh.traverse(function (child) {
        if(child instanceof THREE.Mesh) {
          child.geometry.dispose()
          if(child.material.length > 1) {
            for(var i = 0; i < child.material.length; i++) {
              child.material[i].dispose()
            }
          }else {
            child.material.dispose()
          }
        }
      })
      this.mesh = null
      if(this.resData[num2].panos.length > 0) {
        this.panoGroup.visible = true
        var id = this.resData[num2].panos[num].physicalFile.id
        if(this.resData[num2].model) {
          this.initModel(num2)
        }
        // if(this.resData[num2].sandTable_Point.sandPoints!=null){
        //   var pointNum = this.resData[num2].sandTable_Point.sandPoints.findIndex(item => item.panoID === id)
        //   this.$parent.changePanoEditInfos('sandPointActiveIndex', pointNum)
        // }
        this.lon = 270
        this.lat = 0
        this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
        var r = this.resData[num2].panos[this.nowPanoActiveIndex].physicalFile.filePath
        var urls = [
          r + '/creat/l1_r_1_1.jpg',
          r + '/creat/l1_l_1_1.jpg',
          r + '/creat/l1_u_1_1.jpg',
          r + '/creat/l1_d_1_1.jpg',
          r + '/creat/l1_f_1_1.jpg',
          r + '/creat/l1_b_1_1.jpg'
        ]
        var textureCube = new THREE.CubeTextureLoader().load(urls)
        textureCube.format = THREE.RGBFormat
        textureCube.mapping = THREE.CubeRefractionMapping
        this.panoGroup.children[0].material.uniforms.texture.value = textureCube
      }else{
        this.panoGroup.visible = false
      }
    },
    posObj(obj, cam, r, lon, lat, h) {
      lat = Math.max(-85, Math.min(85, lat))
      var phi = THREE.Math.degToRad(90 - lat)
      var theta = THREE.Math.degToRad(lon)
      obj.position.x = r * Math.sin(phi) * Math.cos(theta) + cam.position.x
      obj.position.y = r * Math.cos(phi) + cam.position.y
      obj.position.z = r * Math.sin(phi) * Math.sin(theta) + cam.position.z
    },
    generatePano(panoGroup, data) {
      var r = data.physicalFile.filePath
      console.log(r)
      var urls = [
        r + '/creat/l1_r_1_1.jpg',
        r + '/creat/l1_l_1_1.jpg',
        r + '/creat/l1_u_1_1.jpg',
        r + '/creat/l1_d_1_1.jpg',
        r + '/creat/l1_f_1_1.jpg',
        r + '/creat/l1_b_1_1.jpg'
      ]
      // var urls = [
      //   r + '/1_r.jpg',
      //   r + '/1_l.jpg',
      //   r + '/1_u.jpg',
      //   r + '/1_d.jpg',
      //   r + '/1_f.jpg',
      //   r + '/1_b.jpg'
      // ]

      var textureCube = new THREE.CubeTextureLoader().load(urls)
      textureCube.format = THREE.RGBFormat
      textureCube.mapping = THREE.CubeRefractionMapping
      var planeUniforms = {
        cPosition: { value: new THREE.Vector3(0, 0, 0) },
        texture: { value: textureCube },
        ...THREE.UniformsLib.lights
      }
      var cubeMat = new THREE.ShaderMaterial({
        uniforms: planeUniforms,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        lights: true
      })
      cubeMat.needsUpdate = true

      // var geometry = new THREE.BoxBufferGeometry(5000, 5000, 5000)
      var geometry = new THREE.SphereBufferGeometry(5000, 32, 32)
      geometry.scale(1, 1, -1)
      var cubeMesh = new THREE.Mesh(geometry, cubeMat)
      cubeMesh.visible = true
      cubeMesh.name = data.fileName
      panoGroup.add(cubeMesh)
    },
    onresize () {
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.camera.aspect = this.containerW / this.containerH
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(this.containerW, this.containerH)
      this.containerWUp = this.$refs.webglUp.getBoundingClientRect().width
      this.containerHUp = this.$refs.webglUp.getBoundingClientRect().height
      this.cameraUp.aspect = this.containerWUp / this.containerHUp
      this.cameraUp.updateProjectionMatrix()
      this.rendererUp.setSize(this.containerWUp, this.containerHUp)
    },
    render() {
      this.renderer.render(this.scene, this.camera)
      this.rendererUp.render(this.sceneUp, this.cameraUp)
    },
    animate () {
      var delta = this.clock.getDelta()
      this.camera.lookAt(this.targetBox.position)
      this.cameraUp.lookAt(this.targetBoxUp.position)
      this.rafId = requestAnimationFrame(this.animate)
      this.render()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onresize, false)
    cancelAnimationFrame(this.rafId)
    this.renderer.dispose()
    this.renderer.forceContextLoss()
    this.renderer.domElement = null
    this.renderer = null
    this.scene = null
    this.camera = null
    this.rafId = null
    this.container = null
    this.mesh = null
    this.controls = null
    this.modelInfo = null
  }
}
</script>
